import { ChangeDetectorRef, Component, ElementRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { PetlService } from '../../../services/petl.service';
import { PetlBaseComponent } from '../petl-base.component';
import { IProcessReport } from '../petl-types';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-petl-validate-ng',
    styleUrls: ['../../sharedStyles/base.scss', '../petl-base.scss', './validate.component.scss'],
    templateUrl: './validate.component.html'
})

export class PetlValidateComponent extends PetlBaseComponent {

    sortIndex?: number;
    successLevelText: string;

    @ViewChild('fileSelectedButton') fileSelectedButton: ElementRef<HTMLElement>;

    constructor(_vcr: ViewContainerRef, protected readonly petlService: PetlService, protected readonly cdr: ChangeDetectorRef) {
        super(_vcr, petlService, cdr);
        this.showIssues = false;
    }

    get validationReport(): IProcessReport {
        return this.petlService.validationReport;
    }

    get enablePromote() {
        return (this.validationReport && this.validationReport.validatedRows + this.validationReport.warningRows) > 0;
    }

    get projectIsTrashable() {
        const project = this.petlService.project;
        return project && project.lineCount === 0 && project.pointCount === 0;
    }

    async promoteData() {
        await this.petlService.promoteData(this.petlService.project).then(() => {
            this.petlService.addProjectToMap(this.petlService.project);
        }, () => {
            this.petlService.changeView('validate');
            this.petlService.promoteErrorOccurred = true;
            this.petlService.promoteDataSubmitted = false;
        });
        this.successLevelText = '';
    }

    toggleShowIssues() {
        this.setIssueCssClass();
        this.showIssues = !this.showIssues;
    }

    setIssueCssClass() {
        for (const row of this.service.validationReport.fileIssueList) {
            if (row.issueList.length) {
                const firstIssue = row.issueList[0];
                firstIssue.cssClass = this.getIssueLabelClass(firstIssue);
            }
        }
    }

    setSuccessfulLevelText() {
        if (this.validationReport) {
            this.successLevelText = this.getSuccessLevelText(this.validationReport.validatedRows, this.validationReport.totalRowsProcessed);
        }
    }

    goBackToMapping() {
        this.petlService.goBackToMapping();
    }

    startOver() {
        this.petlService.startOver();
    }

    getIssueLabelClass(issue) {
        if (issue.type === 'Warning') {
            return 'label-warning';
        } else {
            return 'label-danger';
        }
    }

    trash() {
        this.petlService.deleteProject();
        this.petlService.startOver();
    }

    sorter(item) {
        if (this.sortIndex === 1) {
            return item.issueList[0].columnName;
        } else {
            return item.rowNumber;
        }
    }

    getSuccessLevelText(validated, total) {
        const good = 0.9;
        const fair = 0.5;
        if (validated === total) { return 'Awesome!'; }
        if (validated / total > good) { return 'Looks Good.'; }
        if (validated / total > fair) { return 'Good Enough.'; }
        if (validated > 0) { return 'Ok.'; }
    }

}
